import React, { useState } from 'react';
import styled from 'styled-components';
import styles from './InteractiveExteriorIncidents.module.css';
import { HBox } from '../../../components/Box';

const carPoints = [
  // LEFT PARTS
  { id: 1, top: '16%', left: '36%', part: 'Linksvoor' },
  { id: 2, top: '28%', left: '30%', part: 'Wiel linksvoor' },
  { id: 3, top: '40%', left: '27%', part: 'Spiegel links' },
  { id: 4, top: '48%', left: '31%', part: 'Deur linksvoor' },
  { id: 21, top: '52%', left: '10%', part: 'Linker zijde' },
  { id: 5, top: '66%', left: '31%', part: 'Deur linksachter' },
  { id: 6, top: '76%', left: '31%', part: 'Wiel linksachter' },
  { id: 7, top: '86%', left: '36%', part: 'Linksachter' },

  // CENTRAL PARTS
  { id: 8, top: '11%', left: '50%', part: 'Voorzijde' },
  { id: 9, top: '25%', left: '50%', part: 'Motorkap' },
  { id: 10, top: '38%', left: '50%', part: 'Voorruit' },
  { id: 11, top: '52%', left: '50%', part: 'Dak' },
  { id: 12, top: '67%', left: '50%', part: 'Rondom' },
  { id: 13, top: '89%', left: '50%', part: 'Achter' },

  // RIGHT PARTS
  { id: 14, top: '16%', left: '64%', part: 'Rechtsvoor' },
  { id: 15, top: '28%', left: '71%', part: 'Wiel rechtsvoor' },
  { id: 16, top: '40%', left: '73%', part: 'Spiegel rechts' },
  { id: 17, top: '48%', left: '70%', part: 'Deur rechtsvoor' },
  { id: 22, top: '52%', left: '90%', part: 'Rechter zijde' },
  { id: 18, top: '66%', left: '70%', part: 'Deur rechtsachter' },
  { id: 19, top: '76%', left: '70%', part: 'Wiel rechtsachter' },
  { id: 20, top: '86%', left: '66%', part: 'Rechtsachter' },
];

export const CarExteriorIncidentsInteractive = function({ vehicle, onPartClick }) {
  const [selectedPart, setSelectedPart] = useState(null); // Tracks the currently selected part

  const handleClick = (id, part) => {
    console.log(`Button ${id}-${part} clicked!`);
    setSelectedPart(part); // Update state to only store the selected part
    onPartClick(part);
  };

  return (
    <HBox center style={{ height: '500px' }}>
      <div
        className={styles.container}
        style={{
          backgroundImage: `url('/public/images/car-removebg-preview.png')`,
        }}
      >
        {vehicle?.exterior_damage_free !== '1' &&
          carPoints.map(point => (
            <img
              key={point.id}
              style={{ cursor: 'pointer', top: point.top, left: point.left }}
              className={styles.icon}
              src={
                selectedPart === point.part
                  ? '/public/images/icon_selected.png' // Alternate image when selected
                  : '/public/images/icon_incident.png' // Default image
              }
              width="26"
              onClick={() => handleClick(point.id, point.part)}
            />
          ))}
      </div>
    </HBox>
  );
};
